import { useCallback, useEffect } from 'react'
import { useToastStore } from '~/stores/toastStore'
import { TOAST_DURATION_MS } from './constants'
import styles from './styles.module.css'

/**
 * 操作の結果を画面下に短く出すお知らせ
 * App に1つだけ置き、showToast() で出す
 */
export function ToastHost() {
  const toast = useToastStore((state) => state.toast)
  const dismiss = useToastStore((state) => state.dismiss)

  useEffect(() => {
    if (!toast) return
    const timer = setTimeout(() => dismiss(toast.id), TOAST_DURATION_MS)
    return () => clearTimeout(timer)
  }, [toast, dismiss])

  const handleClose = useCallback(() => {
    if (toast) dismiss(toast.id)
  }, [toast, dismiss])

  if (!toast) return null

  return (
    <div
      key={toast.id}
      className={`${styles.toast} ${styles[toast.kind]}`}
      role={toast.kind === 'error' ? 'alert' : 'status'}
    >
      <span className={styles.message}>{toast.message}</span>
      <button
        type="button"
        className={styles.closeButton}
        onClick={handleClose}
        aria-label="閉じる"
      >
        ×
      </button>
    </div>
  )
}
